import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  seoMarketingIcon,
  socialMarketingIcon,
  payPerClickIcon,
  emailMarketinIcon,
  influencerMarketingIcon,
  analyticIcon,
} from "../../../../assets/icons/serviceIcon/index";
import PersonalBrandingWork from "./PersonalBrandingWork";

const items = [
  {
    name: "Brand Identity Development",
    text: "We figure out your voice, tone, and story then bring it all together into a style that’s unmistakably you.",
  },
  {
    name: "Content Strategy & Storytelling",
    text: "Your experiences, your lessons, and your journey will be turned into content that builds connection, trust, and a real community around you.",
  },
  {
    name: "Profile Optimization & Positioning",
    text: "From your bio to your highlights, everything gets a refresh so when people land on your profile, they instantly get you.",
  },
];

const otherService = [
  {
    icon: seoMarketingIcon,
    name: "Seo & Content Marketing",
    des: "Get ranked on Google and stay in hearts with content that truly speaks to your people.",
    path: "/seo-content-marketing",
  },
  {
    icon: socialMarketingIcon,
    name: "Social Media Marketing (SMM)",
    des: "Show up where your audience scrolls, shares and starts to trust you.",
    path: "/social-media-marketing",
  },
  {
    icon: payPerClickIcon,
    name: "Pay Per Click",
    des: "Get your brand seen by the right people, right when they’re searching for you.",
    path: "/pay-per-click",
  },
  {
    icon: emailMarketinIcon,
    name: "Email & CRM Marketing",
    des: "Stay in touch in a meaningful way with emails people actually want to open.",
    path: "/email-marketing",
  },
  {
    icon: influencerMarketingIcon,
    name: "Influencer & Affiliate Marketing",
    des: "Let others talk about your brand in a way that feels real and relatable.",
    path: "/influencer-marketing",
  },
  {
    icon: analyticIcon,
    name: "Analytics  & Performance Tracking ",
    des: "Know what’s working, what’s not, and what to do next without the guesswork.",
    path: "/analytic-and-performance-tracking",
  },
];

const PersonalBranding = () => {
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Branding"
        description="Your story is your superpower. Whether you're a coach, creator, or founder, we shape your online presence to feel like you, which will be effortless, real and hard to forget."
        heading="Personal"
      />
      <NewCommonServiceForm title="Personal Branding" items={items} />
      <PersonalBrandingWork/>
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default PersonalBranding;
